// ===========================================
//   EditarFacturaModal.jsx — Modal Edición Factura (COREX Premium)
// ===========================================

import React from "react";

const API = "/api";


export default function EditarFacturaModal({ open, onClose, factura, onSaved }) {
  if (!open || !factura) return null;

  // ============================
  //  ESTADO LOCAL (CONTROLADO)
  // ============================
  const [data, setData] = React.useState({
    numero: factura.numero ?? "",
    fechaEmision: factura.fechaEmision
      ? factura.fechaEmision.split("T")[0]
      : "",
    notas: factura.notas ?? "",
    estado: factura.estadoFactura ?? "pendiente",
  });

  // Actualizar campos locales
  const update = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
  };

  // ============================
  //  GUARDAR CAMBIOS
  // ============================
  async function guardar() {
    try {
      const res = await fetch(`${API}/facturas/${factura.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          numero: data.numero ?? "",
          fechaEmision: data.fechaEmision ?? "",
          notas: data.notas ?? "",
          estado: data.estado ?? "pendiente",
        }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || "Error guardando factura");
      }

      alert("Factura actualizada correctamente");
      onSaved(); // refrescar lista
      onClose(); // cerrar modal
    } catch (err) {
      alert(err.message);
    }
  }

  // ============================
  //  RENDER
  // ============================
  return (
    <div className="modal-overlay">
      <div
        className="modal-content presupuestos-modal"
        style={{
          width: "90vw",
          maxWidth: "850px",
          height: "80vh",
          background: "rgba(15,23,42,0.92)",
          borderRadius: 18,
          color: "#F9FAFB",
          border: "1px solid rgba(255,255,255,0.12)",
          display: "flex",
          flexDirection: "column",
          backdropFilter: "blur(14px)",
          boxShadow: "0 0 25px rgba(0,0,0,0.45)",
        }}
      >
        {/* HEADER */}
        <div
          className="modal-header sticky-top"
          style={{
            padding: "18px 26px",
            borderBottom: "1px solid rgba(255,255,255,0.12)",
            display: "flex",
            justifyContent: "space-between",
            background: "rgba(15,23,42,0.8)",
            backdropFilter: "blur(8px)",
            zIndex: 20,
          }}
        >
          <h2 style={{ margin: 0 }}>Editar Factura</h2>

          <button
            className="glass-btn"
            onClick={onClose}
            style={{
              fontSize: 18,
              width: 38,
              height: 38,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ✕
          </button>
        </div>

        {/* BODY */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "26px",
            paddingTop: "18px",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 22,
          }}
        >
          {/* NUMERO */}
          <div className="field" style={{ gridColumn: "1 / span 2" }}>
            <label style={{ opacity: 0.85 }}>Número</label>
            <input
              className="glass-input"
              value={data.numero}
              onChange={(e) => update("numero", e.target.value)}
            />
          </div>

          {/* FECHA */}
          <div className="field">
            <label style={{ opacity: 0.85 }}>Fecha emisión</label>
            <input
              type="date"
              className="glass-input"
              value={data.fechaEmision}
              onChange={(e) => update("fechaEmision", e.target.value)}
            />
          </div>

          {/* ESTADO */}
          <div className="field">
            <label style={{ opacity: 0.85 }}>Estado</label>
            <select
              className="glass-input"
              value={data.estado}
              onChange={(e) => update("estado", e.target.value)}
            >
              <option value="pendiente">Pendiente</option>
              <option value="pagada">Pagada</option>
              <option value="cancelada">Cancelada</option>
            </select>
          </div>

          {/* NOTAS */}
          <div className="field" style={{ gridColumn: "1 / span 2" }}>
            <label style={{ opacity: 0.85 }}>Notas</label>
            <textarea
              className="glass-input"
              rows={4}
              style={{ resize: "vertical" }}
              value={data.notas}
              onChange={(e) => update("notas", e.target.value)}
            />
          </div>
        </div>

        {/* FOOTER */}
        <div
          className="modal-footer sticky-bottom"
          style={{
            padding: "18px 26px",
            borderTop: "1px solid rgba(255,255,255,0.12)",
            display: "flex",
            justifyContent: "flex-end",
            gap: 14,
            background: "rgba(15,23,42,0.8)",
            backdropFilter: "blur(6px)",
          }}
        >
          <button className="glass-btn" onClick={onClose}>
            Cancelar
          </button>

          <button className="glass-btn primary" onClick={guardar}>
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
  );
}

